import React,{useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { useGlobalContext } from '../context'

export const Home = () => {
    const [difficulty, setDifficulty] = useState('');
    const [amount, setAmount] = useState(10);
    const [category, setCategory] = useState('');
    const {timer, setTimer } = useGlobalContext();
    
    const [id, setID] = useState(`amount=${amount}&category=${category}&difficulty=${difficulty}&type=multiple`)
    const [easy, setEasy] = useState(false)
    const [medium, setMedium] = useState(false)
    const [hard, setHard] = useState(false)
    const [mix, setmix] = useState(false)
    
    
    useEffect(() => {
        if (category === '' && difficulty === '')
            setID(`amount=${amount}&type=multiple`)
        else if (category !== '' && difficulty === '')
            setID(`amount=${amount}&category=${category}&type=multiple`)
        else if (difficulty !== '' && category === '')
            setID(`amount=${amount}&difficulty=${difficulty}&type=multiple`)
    },[amount, difficulty, category,id])
    
    const btnHandler = (e) => {
        let val = e.target.textContent;
        if (val === 'Easy') {
            setDifficulty('easy');
            setEasy(!easy);
            setMedium(false);
            setHard(false);
            setmix(false);
        }
        if (val === 'Medium') {
            setDifficulty('medium');
            setEasy(false);
            setMedium(!medium);
            setHard(false);
            setmix(false);
        }
        if (val === 'Hard') {
            setDifficulty('hard');
            setEasy(false);
            setMedium(false);
            setHard(!hard);
            setmix(false);
        }
        if (val === 'Mixed') {
            setDifficulty('');
            setEasy(false);
            setMedium(false);
            setHard(false);
            setmix(!mix);
        }
    }

    const amountHandler = (e) => {
        if (e.target.value > 50)
            setAmount(50)
        else if (e.target.value < 10)
            setAmount(10)
        else
            setAmount(e.target.value)
    }

    const timerHandler = () => {
        setTimer(!timer);
    }
  
    return (
        <div className='container mr-auto bg-main rounded p-5'>
            <div className='text-center'>
                <h2 className='white'>Welcome to Trivia Quiz Game!</h2>
            </div>
            <div>
                <div className='d-flex pt-3'>
                    <button type="button" className='btn aqua' disabled>Amount</button>
                    <input onChange={amountHandler} type="number" className="form-control w-50" placeholder="Amount" value={amount} />
                </div>
                <div className="form-group d-flex pt-3">
                    <button type="button" className='btn lime' disabled>Category</button>
                    <select  onChange={(e) => setCategory(e.target.value)} className="form-control w-50    " id="exampleFormControlSelect1">
                        <option value="any">Any Category</option>
                        <option value="9">General Knowledge</option>
                        <option value="10">Entertainment: Books</option>
                        <option value="11">Entertainment: Film</option>
                        <option value="12">Entertainment: Music</option>
                        <option value="13">Entertainment: Musicals &amp; Theatres</option>
                        <option value="14">Entertainment: Television</option>
                        <option value="15">Entertainment: Video Games</option>
                        <option value="16">Entertainment: Board Games</option>
                        <option value="17">Science &amp; Nature</option>
                        <option value="18">Science: Computers</option>
                        <option value="19">Science: Mathematics</option>
                        <option value="20">Mythology</option>
                        <option value="21">Sports</option>
                        <option value="22">Geography</option>
                        <option value="23">History</option>
                        <option value="24">Politics</option>
                        <option value="25">Art</option>
                        <option value="26">Celebrities</option>
                        <option value="27">Animals</option>
                        <option value="28">Vehicles</option>
                        <option value="29">Entertainment: Comics</option>
                        <option value="30">Science: Gadgets</option>
                        <option value="31">Entertainment: Japanese Anime &amp; Manga</option>
                        <option value="32">Entertainment: Cartoon &amp; Animations</option>
                    </select>
                </div>
                <div className='d-flex'>
                    <div className="btn-group d-block pb-2" role="group" aria-label="First group">
                        <button type="button" className='btn coral' disabled>Difficulty</button>
                        <button onClick={btnHandler} type="button" className={easy ? 'btn btn-success'  : 'btn btn-default' }>Easy</button>
                        <button onClick={btnHandler} type="button" className={medium ? 'btn btn-warning'  : 'btn btn-default' }>Medium</button>
                        <button onClick={btnHandler} type="button" className={hard ? 'btn btn-danger '  : 'btn btn-default' }>Hard</button>
                        <button onClick={btnHandler} type="button" className={mix ? 'btn purple'  : 'btn btn-default' }>Mixed</button>
                    </div>
                    <div className="custom-control custom-switch mt-2 mb-2 ml-4">
                        <input onClick={timerHandler} type="checkbox" className="custom-control-input" id="customSwitch1"/>
                        <label className="custom-control-label white" htmlFor="customSwitch1">Timer</label>
                    </div>
                </div>
                <Link to={`/play/${id}`} className='btn btn-dark btn-play'>Start</Link>
            </div>
        </div>
    )
}

export default Home